import axios from "axios";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import NavBar from "../../NavBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { responsivePropType } from "react-bootstrap/esm/createUtilityClasses";

const Testimonial = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [testimonial, setTestimonial] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState();

  const  testimonials= () => {
    const token = localStorage.getItem("token");

    axios.post(`${BASE_URL}admin/getAllTestimonial/${currentPage}`, {}, {
      headers: {
        "Content-Type": "Application/json",
        "version": "1.0.0",
        "x-access-token": `${token}`
      }
    }).then((res) => {
      if (res.data.success) {
        setTestimonial(res.data.data);
          setPages(res.data.remainingCount);
      } else {
        // toast.error(res.data.message);
      }
    }).catch((err) => {
      console.log(err.message);
    })

  }


  const deleteTestimonial=(id)=>{
    if (window.confirm("Do you really want to delete this item?")) {

    } else {

      return;
    }
    
    const token=localStorage.getItem('token');
axios.delete(`${BASE_URL}admin/deleteTestimonial/${id}`,{
  headers:{
    "Content-Type":"Application/json",
    "version":"1.0.0",
    "x-access-token":`${token}`
  }}).then((response)=>{
    if(response.data.success){
      toast.error(response.data.message);
      testimonials()
    }
  }).catch((error)=>{
    console.log(error.message);
  })
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
    testimonials(page);

  }
  useEffect(() => {
    testimonials();
  }, [currentPage])


  return (
    <>
      <NavBar />
      <div className="container p-3">

        <div style={{ overflowX: "auto" }}>
          <div className="scrollit">
            <span style={{ fontSize: '20px', fontWeight: '600' }} className="p-2">All User List</span>
            <hr style={{ width: '165px', fontWeight: '700', color: 'grey' }}></hr>


            <Table striped bordered hover >
              <thead>
                <tr>
                  {/* <th>#</th> */}
                  <th>S no.</th>
<th>Image</th>
                  <th>Name</th>
                  {/* <th> Mobile no.</th> */}
                  <th>Comment</th>
                  <th>Rating</th>
                  <th>Created At</th>
                  {/* <th>created At:</th> */}


                  <th>Status:</th>
                  {/* <th>Date:</th> */}
                  {/* <th>Date:</th> */}
                  <th>Action</th>

                </tr>
              </thead>
              <tbody>

                {
                  testimonial.map((item, index) => (
                    <tr key={index}>
                      <td>{(currentPage > 1 ? (currentPage - 1) * 10 : 0) + index + 1}</td>
                      <td className="tabletd">
                        <img src={item.image} style={{ width: '40px' }}></img>
                        {/* {(currentPage > 1 ? (currentPage - 1) * 10 : 0) + index + 1} */}
                      </td>
                      <td>
                        {/* <Image src={item.icon} style={{ width: '40px' }}></Image> */}
                        {item.name}
                      </td>
                      {/* <td>
                        {item.mobile_no}
                        </td> */}
                      <td>
                        {item.description}

                      </td>
                      <td>
                        {item.rate}

                      </td>
                    
                      <td>
                        {moment(item.createdAt).format("DD-MM-yy")}

                      </td>
                      <td>
                        {item.status}

                      </td>
                      {/* <td>
                        {item.date}
                        
                      </td> */}
                      <td>
                        {/* <button type="button" class="btn btn-primary btn-sm m-1 " onClick={() => changeStatus(item._id)} style={{
                          width: "40px",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",

                        }}><abbr title="Change Status">Change Status</abbr> </button>
                        &nbsp;
                        <br /> */}

                        <button type="button" class="btn btn-danger btn-sm m-1 " 
                          onClick={() => deleteTestimonial(item._id)}><i className="fa fa-trash"></i></button>


                      </td>

                    </tr>

                  ))
                }

                {/* <tr>
                  <td>2</td>
                  <td><Image src="#" style={{ width: '40px' }}></Image></td>
                  <td>Thornton</td>
                  <td>InActive</td>
                  <td>
                    <button type="button" class="btn btn-primary "><i className="fa fa-edit"></i> </button>
                    &nbsp; &nbsp;
                    <button type="button" class="btn btn-danger "><i className='fa fa-trash'></i> </button>
                  </td>
                </tr> */}
                {/* <tr>
                  <td>3</td>
                  <td ><Image src="#" style={{ width: '40px' }}></Image></td>
                  <td>gujh</td>
                  <td>Active</td>
                  <td>
                    <button type="button" class="btn btn-primary "><i className="fa fa-edit"></i> </button>
                    &nbsp; &nbsp;
                    <button type="button" class="btn btn-danger "><i className='fa fa-trash'></i> </button>
                  </td>
                </tr> */}
              </tbody>
              {/* pagination  */}
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class={`page-item ${currentPage === 1 ? "disabled" : ""} `}>
                    <a class="page-link" href="#" aria-label="Previous" onClick={() => handlePageChange(currentPage - 1)}>
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>


                  {Array.from({ length: pages }, (_, i) => i + 1).map((page) => (
                    <>
                      <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    </>
                  ))}
                  <li class={`page-item ${currentPage === pages ? "disabled" : ""}`}>
                    <a class="page-link" href="#" aria-label="Next" onClick={() => handlePageChange(currentPage + 1)}>
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
              {/* pagination end  */}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}
export default Testimonial;